import CompLayout from "@/pcomponents/comp/layout/layout";
import { useNavigate,useLocation } from 'react-router-dom';
import StuListViewArea from "@/pages/comp/basic/student/common/list_view";

function StuListViewPage() {
  const navigate = useNavigate();
  const { state } = useLocation();
  let page_state:any={
    write_page_data:{},
    callback_refresh_data: (inData: any) => { },
    ...state
  };
  
  return (
    <CompLayout>
      <StuListViewArea 
        write_page_data={page_state.write_page_data}
        callback_refresh_data={page_state.callback_refresh_data}
        closePopup={()=>{navigate("/comp/basic/student/list")}}
        ></StuListViewArea>
    </CompLayout>
  );
};
export default StuListViewPage;